import './ReportFormFieldUpload.scss';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { FormattedMessage } from 'react-intl';
import { FILE_ACCEPT_DOCUMENT } from 'src/modules/common/constants/fileField';
import { UploadIcon } from 'src/modules/common/icons/UploadIcon';

type Props = {
  readonly onUpload: (file: File) => void;
};

export const ReportFormFieldUpload = ({ onUpload }: Props): React.ReactElement => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: FILE_ACCEPT_DOCUMENT,
    onDrop: (accepted, rejected) => {
      accepted.forEach((it) => onUpload(it));
      rejected.forEach((it) => onUpload(it.file));
    },
  });

  return (
    <div {...getRootProps()} className="bp-report-form-field-upload">
      <input {...getInputProps()}/>

      <div className="bp-report-form-field-upload__text">
        <FormattedMessage id="report/form/appendix/upload/button"/>
      </div>
      <div className="bp-report-form-field-upload__icon">
        <UploadIcon/>
      </div>
    </div>
  );
};
